export const FEATURE_KEYS = {
  CASHIA_DEPOSIT_EXPERIMENT: 'WP-9411-enable-cashia-integration',
  JACKPOT_MUST_BE_WON: 'SB-3076-enable-MustBeWon-jackpot',
  CASHIA_WITHDRAW_EXPERIMENT: 'WAL-2941-Enable-Cashia-Withdrawals'
  // add more KEYS here as needed i.e  WITHDRAWAL: 'WP-9500-enable-withdrawal-integration'
}
